// services/symbolService.js
import axios from 'axios';

// Spot symbols come from the LEGACY backend (REACT_APP_BACKEND_URL,
// api.cryptologics-ai.com in prod) — its database and Redis cache hold the
// full symbol catalog, including all ~13.9k Alpaca tickers with the stock
// metadata the category chips read. crypto-backend-api serves the same
// route (routes/symbolCatalog.js) against the main RDS, so flipping this to
// API_BASE_URL is a one-line change once that RDS's Symbols table is seeded.
// NOTE for local dev: set REACT_APP_BACKEND_URL in .env.development to the
// deployed legacy backend — its default localhost:3000 is the CRA server
// itself, which can never answer this.
const LEGACY_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000';

async function get(exchange, format = 'objects') {
  if (!exchange) return [];
  const { data } = await axios.get(`${LEGACY_BASE}/api/symbolexchange`, {
    params: { exchange, format }
  });
  console.log('symbolService data:', data);
  return Array.isArray(data) ? data : [];
}

async function getFutures(exchange, marketType = 'usdm_futures', format = 'objects') {
  if (!exchange) return [];
  // Futures symbols still come from the legacy backend — the main backend's
  // database has no FuturesSymbols table (yet).
  const { data } = await axios.get(`${LEGACY_BASE}/api/futuresymbolexchange`, {
    params: { exchange, market_type: marketType, format },
  });
  console.log('symbolService futures data:', exchange, marketType, data?.length);
  return Array.isArray(data) ? data : [];
}

export default { get, getFutures };